import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { SettingsProductStocksChange } from "features/stock-ordering/core/stock-ordering.params";
import {
  stockOrderSettingsProductInfoChangesResponse,
  stockOrderSettingsProductInfoChangesRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum stockOrderSettingsProductInfoChangesState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: stockOrderSettingsProductInfoChangesState;
  message: string;
}

const initialState: InitialState = {
  status: stockOrderSettingsProductInfoChangesState.initial,
  message: "",
};

export const stockOrderSettingsProductInfoChanges = createAsyncThunk(
  "stockOrderSettingsProductInfoChanges",
  async (param: SettingsProductStocksChange, { rejectWithValue }) => {
    try {
      const response: stockOrderSettingsProductInfoChangesResponse =
        await stockOrderSettingsProductInfoChangesRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const stockOrderSettingsProductInfoChangesSlice = createSlice({
  name: "stockOrderSettingsProductInfoChanges",
  initialState,
  reducers: {
    resetstockOrderSettingsProductInfoChanges: (state) => {
      state.status = stockOrderSettingsProductInfoChangesState.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(stockOrderSettingsProductInfoChanges.pending, (state) => {
        state.status = stockOrderSettingsProductInfoChangesState.inProgress;
      })
      .addCase(
        stockOrderSettingsProductInfoChanges.fulfilled,
        (state, action) => {
          if (action.payload) {
            const { message } = action.payload;
            state.status = stockOrderSettingsProductInfoChangesState.success;
            state.message = message;
          }
        }
      )
      .addCase(
        stockOrderSettingsProductInfoChanges.rejected,
        (state, action) => {
          state.status = stockOrderSettingsProductInfoChangesState.fail;
          state.message = action.payload as string;
        }
      );
  },
});

export const selectStockOrderSettingsProductInfoChanges = (state: RootState) =>
  state.stockOrderSettingsProductInfoChanges;

export const { resetstockOrderSettingsProductInfoChanges } =
  stockOrderSettingsProductInfoChangesSlice.actions;
export default stockOrderSettingsProductInfoChangesSlice.reducer;
